import { logger } from "./logger";

export const scrollToId = (id: string) => {
  setTimeout(() => {
    const scrollTarget = document.getElementById(id);

    if (scrollTarget) {
      logger.info(`scrollToId: ${id}, ${scrollTarget.scrollHeight}`);
      scrollTarget.scrollIntoView({ behavior: "smooth" });
    } else {
      logger.error(`scrollToId: ${id} not found`);
    }
  }, 50);
};
